import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import authService from "../services/auth-service";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Alert } from "@mui/material";

export default function ChangePassword() {
	const { t, i18n } = useTranslation();
	const [err, setErr] = React.useState();
	const navigate = useNavigate();
	const handleSubmit = (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		const oldPassword = data.get("oldPassword") || "";
		const newPassword = data.get("newPassword") || "";
		authService
			.resetPassword(oldPassword.toString(), newPassword.toString())
			.then(
				() => {
					navigate("/");
				},
				(error) => {
					if (error.response.data.message)
						setErr(
							typeof error.response.data.message === "array"
								? error.response.data.message[0]
								: error.response.data.message
						);
					else setErr(error.response.statusText);
				}
			);
	};

	return (
		<Grid
			container
			direction="column"
			width="80vw"
			height={"100vh"}
			alignItems="center"
			justifyContent="space-around">
			<Grid item>
				<Grid
					container
					direction="column"
					alignItems="center"
					justifyContent="space-around">
					<Box
						m="2vw"
						component="form"
						onSubmit={handleSubmit}
						noValidate
						sx={{ mt: 1 }}>
						<TextField
							margin="normal"
							required
							fullWidth
							id="oldPassword"
							label={t("AUTH.OLD_PASSWORD")}
							type="password"
							name="oldPassword"
							autoComplete="oldPassword"
							autoFocus
							focused={true}
						/>
						<TextField
							margin="normal"
							required
							fullWidth
							name="newPassword"
							label={t("AUTH.NEW_PASSWORD")}
							type="password"
							id="oldPassword"
							autoComplete="current-password"
							focused={true}
						/>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							sx={{ mt: 3, mb: 2 }}>
							{t("AUTH.CHANGE_PASSWORD")}
						</Button>

						{!!err && <Alert severity="error">{t(`ERROR.${err}`)}</Alert>}
					</Box>
				</Grid>
			</Grid>
		</Grid>
	);
}
